export function nonEmptyField(value, fieldName) {
  let message = `${fieldName} can not be empty`;
  return !!value || message;
}

export function onlyCharsAndNumbers(value, fieldName) {
  let message = `${fieldName} cannot contain spaces or special chars`;
  return /^[a-zA-Z0-9]+$/.test(value) || message
}

export function validPassword(value) {
  let message = "Min. 8 characters with at least one uppercase, one lowercase, a number and a special character.";
  const patternNumbers = /^(?=.*[0-9])(?=.{8,})/;
  const patternLower = /^(?=.*[a-z])(?=.{8,})/;
  const patternUpper = /^(?=.*[A-Z])(?=.{8,})/;
  const patternSpecials = /^(?=.*[\!\@\#\$\%\^\&\*\(\)\,\.\?\"\:\{\}\|\<\>\ª\·\º\\\-\_])(?=.{8,})/;
  return (patternNumbers.test(value) && patternLower.test(value) && patternUpper.test(value) && patternSpecials.test(value)) || message;
}

export function validUrl(value) {
    const message = 'The provided url is not valid';
    const pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
      '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    return !!pattern.test(value) || message;
}

export function linkedinProfileUrl(value) {
  const message = 'The url must be something like https://www.linkedin.com/in/...';
  const pattern = new RegExp('^https:\/\/www\.linkedin\.com\/in\/(.+)','i');
  return !!pattern.test(value) || message;
}

export function linkedinCompanyUrl(value) {
  const message = 'The url must be something like https://www.linkedin.com/company/...';
  const pattern = new RegExp('^https:\/\/www\.linkedin\.com\/(company|school)\/(.+)','i');
  return !!pattern.test(value) || message;
}

export function validEmail(value) {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return pattern.test(value) || 'Invalid e-mail.'
}

export function size (vue) {
  const size = {xs:'small',sm:'small',lg:'',xl:'large'}[vue.$vuetify.breakpoint.name];
  return size ? { [size]: true } : {}
}

export function getBreakpoint(vue){
  return vue.$vuetify.breakpoint.name;
}

export function generateCsv(response){
  const url = window.URL.createObjectURL(new Blob([
    new Uint8Array([0xEF, 0xBB, 0xBF]),
    response.data
  ], { type: "text/plain;charset=utf-8" }));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `export-${new Date().toISOString()}.csv`); //or any other extension
  document.body.appendChild(link);
  link.click()
}

export function generateJson(response){
  const url = window.URL.createObjectURL(new Blob([
    JSON.stringify(response.data.data)
  ]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `export-${new Date().toISOString()}.json`); //or any other extension
  document.body.appendChild(link);
  link.click()
}

export function remove(data, keys) {
  for(let i in data) {
    if(keys.includes(i)) delete data[i];
    else if(typeof data[i] === 'object') remove(data[i], keys)
  }
}

export function getNumberOfChangesInSection(item){
  return item ? Object.keys(item).filter(e => e !== '_t').length : 0;
}

export function mapEngagementColor(value) {
  let engClass = '';
  switch(value) {
    case 0:
      engClass = 'success';
      break;
    case 1:
      engClass = 'warning';
      break;
    case 2:
      engClass = 'error';
      break;
    default:
      engClass = 'primary';
      break;
  }
  return engClass;
}

export function mapContactChanceColor(value) {
  let contactChanceColor = '';
  switch(value) {
    case 0:
      contactChanceColor = 'blue';
      break;
    case 1:
      contactChanceColor = 'purple';
      break;
    case 2:
      contactChanceColor = 'error';
      break;
    default:
      contactChanceColor = 'primary';
      break;
  }
  return contactChanceColor;
}

export function mapContactChanceLabel(value) {
  let contactChanceLabel = '';
  switch(value) {
    case 0:
      contactChanceLabel = 'Cold';
      break;
    case 1:
      contactChanceLabel = 'Average';
      break;
    case 2:
      contactChanceLabel = 'Hot';
      break;
    default:
      contactChanceLabel = '-';
      break;
  }
  return contactChanceLabel;
}

export function kFormatter(num) {
  return Math.abs(num) > 999 ? Math.sign(num)*((Math.abs(num)/1000).toFixed(1)) + 'k' : Math.sign(num)*Math.abs(num);
}

export function formatRange(range) {
  if (range.min === 0) {
    return `< ${kFormatter(range.max)}`;
  } else if (range.max === null) {
    return `> ${kFormatter(range.min)}`;
  } else {
    return `${kFormatter(range.min)} - ${kFormatter(range.max)}`;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/helpers.js